export default __webpack_public_path__ + "static/media/location.d2150911.svg";